export const SITUACAO_EXECUTADA = 1
export const SITUACAO_NAO_EXECUTADA = 0

export const SITUACOES_TASK_LABEL = {
  [SITUACAO_EXECUTADA]: {
    label: 'Executada',
    class: 'success'
  },
  [SITUACAO_NAO_EXECUTADA]: {
    label: 'Pendente',
    class: 'warning'
  }
}



// WEBPACK FOOTER //
// ./src/domain/tasks-detro/helpers/task-status.js